import { render, staticRenderFns } from "./addProcess.vue?vue&type=template&id=2da56380&scoped=true&"
import script from "./addProcess.vue?vue&type=script&lang=js&"
export * from "./addProcess.vue?vue&type=script&lang=js&"
import style0 from "./addProcess.vue?vue&type=style&index=0&id=2da56380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da56380",
  null
  
)

export default component.exports